import { Loader2 } from 'lucide-react';

/**
 * PageLoader
 *
 * Loader visual compartido para transiciones de rutas y estados de auth-loading.
 * Uso principal:
 *   - Suspense fallback en `<AuthenticatedLayout>` mientras se hidrata una página lazy.
 *   - Estado inicial de `/api/auth/me` mientras se resuelve la sesión.
 *
 * Diseñado para NO ocupar la pantalla entera cuando se usa dentro del layout — el
 * header y las tabs siguen visibles alrededor, y solo el área de contenido cambia.
 * Cuando se necesita fullscreen (pantalla de auth) usar la prop `fullScreen`.
 *
 * `data-testid='page-loader'` para pruebas.
 */
export default function PageLoader({ fullScreen = false }) {
  if (fullScreen) {
    return (
      <div
        className="flex items-center justify-center min-h-screen bg-gradient-to-b from-slate-900 to-slate-800"
        data-testid="page-loader"
        data-variant="fullscreen"
      >
        <Loader2 className="w-8 h-8 animate-spin text-purple-500" />
      </div>
    );
  }
  return (
    <div
      className="flex items-center justify-center py-24"
      data-testid="page-loader"
      data-variant="compact"
    >
      <Loader2 className="w-8 h-8 animate-spin text-purple-500" />
    </div>
  );
}
